<template>
  <!-- Inline SVG, since flag emoji do not render on Windows -->
  <svg class="lang-flag" viewBox="0 0 30 20" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">
    <template v-if="lang === 'id'">
      <rect width="30" height="10" fill="#e70011" />
      <rect y="10" width="30" height="10" fill="#fff" />
    </template>
    <!-- Union Jack (2:1), centred and cropped at the sides to fit 3:2 -->
    <svg v-else x="-5" width="40" height="20" viewBox="0 0 60 30">
      <clipPath :id="clipId">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" :clip-path="`url(#${clipId})`" stroke="#c8102e" stroke-width="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#c8102e" stroke-width="6" />
    </svg>
  </svg>
</template>

<script>
let uid = 0;

export default {
  name: "LangFlag",
  props: {
    // Language code: "id" shows Indonesia, "en" shows the United Kingdom
    lang: { type: String, required: true },
  },
  data() {
    // Unique per instance so two flags on one page do not share a clip path
    return { clipId: `lang-flag-gb-${++uid}` };
  },
};
</script>

<style scoped lang="scss">
.lang-flag {
  display: block;
  width: 18px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
}
</style>
